import { DefaultImageProps } from './types';
import { NAME_LOGO_WHITE_IMAGE_URL } from './urls';

export const NameLogoWhiteImage = ({ className, ...props }: DefaultImageProps) => (
  <img
    className={className}
    src={NAME_LOGO_WHITE_IMAGE_URL}
    alt="name-logo"
    {...props}
  />
);
